var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21h-19A2.503 2.503 0 0 1 0 18.5v-13C0 4.122 1.122 3 2.5 3h19C22.878 3 24 4.122 24 5.5v13c0 1.378-1.122 2.5-2.5 2.5zM2.5 4C1.673 4 1 4.673 1 5.5v13c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5z",
    fill: "#dd3751",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12C6.122 12 5 10.878 5 9.5S6.122 7 7.5 7 10 8.122 10 9.5 8.878 12 7.5 12zm0-4C6.673 8 6 8.673 6 9.5S6.673 11 7.5 11 9 10.327 9 9.5 8.327 8 7.5 8zM11.5 17a.5.5 0 0 1-.5-.5v-1c0-.827-.673-1.5-1.5-1.5h-4c-.827 0-1.5.673-1.5 1.5v1a.5.5 0 0 1-1 0v-1C3 14.122 4.122 13 5.5 13h4c1.378 0 2.5 1.122 2.5 2.5v1a.5.5 0 0 1-.5.5zM20.5 9h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zM20.5 13h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zM20.5 17h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1z",
    fill: "#dd3751",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactcard);
export default __webpack_public_path__ + "static/media/contactcard.a19bd87412559700218fe96fa25108d2.svg";
export { ForwardRef as ReactComponent };